import FormErrorBanner from 'Components/Element/FormErrorBanner';
import React, { useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { autoSignIn, confirmSignUp, resendSignUpCode, signIn } from 'aws-amplify/auth';
import Logo from 'Components/Icons/Logo';
import { Context } from 'Context/Context';
import { CLIENT, PROFESSIONAL, FIRM, sendEmailApi, updateUserProfessionalApi } from 'Constants';
import QCRLogoMark from 'Components/Icons/QCRLogoMark';
import { sendFunderInfoForApproval } from 'Utils';


function ConfirmationPage({currentPassword}) {
    const [apiError, setApiError] = useState(null);
    const [email, setEmail] = useState("");
    const {userDetails, makeApiCallFunc} = useContext(Context);
    const [successMsg, setSuccessMsg] = useState(null);
    const navigate = useNavigate();
    const [confirmationCode, setConfirmationCode] = useState("");
    const confirmCode = async() => {
      console.log(userDetails);
      try {
        const data = await confirmSignUp({
          username: email,
          confirmationCode: confirmationCode,
        });
        console.log("confirm sign up", data);
        if(data.isSignUpComplete)
        {
          console.log("isSignUpComplete" , data);
          setApiError("");
          setSuccessMsg("User confirmed successfully !");
          try {
            const signin = await signIn({username: email, password:currentPassword});
            console.log("signin", signin);
            // welcome email is now sent by the server on the first signed-in visit (auth.js)
            console.log("userDetails after confirm", userDetails);
            if(userDetails)
            {
            // attorneys and law firms go straight to completing their profile
            (userDetails.role === PROFESSIONAL || userDetails.role === FIRM)
            ?
            navigate("/attorney/profileCompletion")
            :
            navigate("/")
            }
            else
            {
              navigate("/");
            }
          } catch (error) {
            setApiError("Could not sign in. Please sign in manually");
            navigate("/signin");
          }

        }
      } catch (error) {
        setSuccessMsg("");
        console.log(JSON.stringify(error));
        if(error?.name === "ExpiredCodeException")
        {
          setApiError("Code was either expired or invalid. Please verify the email id and the code or request for resend if code was not received");
        }
        else if(error?.name === "CodeMismatchException")
        {
          setApiError("Code provided is incorrect.");
        }
        else
        {
          setApiError(error?.message);
        }
      }

    }

    const sendJoiningEmail = (data, email) => {
      console.log("sendJoiningEmail", data, email);
      makeApiCallFunc(sendEmailApi, {
        "recipientEmail" : email,
        "subject" : "Welcome to our website",
        "title" : "Thank you for registering. Your profile is active now !",
        "content" : (
                  data.role === CLIENT ?
                  `You can now post your cases and connect with the professionals to take up your cases.`
                  :
                  `You can now view the cases posted by the clients and take up the cases.`
        ),
        },
        (data) => console.log(data),
        (data) => console.log(data)
        )
      }
    const resendCode = async() => {
      console.log(email)

      try {
        const resendCode = await resendSignUpCode({username:email});
       if(resendCode)
         {
          console.log(resendCode);
          setApiError("");
          setSuccessMsg("Code sent successfully");
        }else {
          setSuccessMsg("");
          setApiError("Error sending code");
        }
      }
       catch (error) {
        console.log(JSON.stringify(error));
        setSuccessMsg("");
        console.log(error?.message)
        if(error?.name === "EmptySignUpUsername" || error?.name === "EmptyConfirmSignUpUsername")
        {
          setApiError("Please enter your email address");
        }
        else
        {
          setApiError(error?.message);
        }
      }
    }
  return (
    <div className="min-h-screen w-full bg-cream font-plexsans flex flex-col items-center">
        <div className="w-full bg-ivory border-b border-navy/10 flex justify-center py-4 lg:py-5">
            <Link to="/" className="flex items-center gap-2">
                <QCRLogoMark/>
                <span className="flex items-start gap-1">
                    <span className="font-plexsans font-semibold text-[12px] tracking-wide uppercase text-navy">Quick Case Review</span>
                    <span className="font-plexmono font-medium text-[7px] tracking-widest uppercase text-tan mt-px">Beta</span>
                </span>
            </Link>
        </div>

        <div className="w-full flex-1 flex items-start lg:items-center justify-center px-4 py-10 lg:py-14">
        <div className="w-full max-w-[460px]">
        <div className="bg-ivory border border-navy/[0.14] rounded p-7 lg:p-8">

            <h1 className="font-spectral font-normal text-navy text-[22px] lg:text-[23px] text-center leading-[1.3] m-0 mb-7">
                Verify your email<br/>to complete registration
            </h1>

            <FormErrorBanner>{apiError}</FormErrorBanner>
            {successMsg ? (
              <div className="flex items-start gap-2 mb-4 px-3.5 py-3 bg-[rgba(20,33,61,.05)] border border-navy/[0.14] rounded-sm">
                <p className="m-0 font-plexsans text-[13px] leading-[1.5] text-navy text-left">{successMsg}</p>
              </div>
            ) : null}

            <div className="flex flex-col gap-3">
                <div>
                    <label className="block font-plexsans text-[12.5px] text-navy/70 mb-1.5">Registered email address</label>
                    <input
                        type="text"
                        name="email"
                        placeholder="example@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value.trim())}
                        onFocus={() => setApiError("")}
                        className="w-full font-plexsans text-[14px] text-navy px-3.5 py-3.5 bg-cream border border-navy/[0.18] rounded-sm outline-none placeholder:text-navy/40"
                    />
                </div>
                <div>
                    <label className="block font-plexsans text-[12.5px] text-navy/70 mb-1.5">Confirmation code</label>
                    <input
                        type="text"
                        name="code"
                        placeholder="******"
                        value={confirmationCode}
                        onChange={(e) => setConfirmationCode(e.target.value.trim())}
                        onFocus={() => setApiError("")}
                        className="w-full font-plexsans text-[14px] text-navy px-3.5 py-3.5 bg-cream border border-navy/[0.18] rounded-sm outline-none placeholder:text-navy/40"
                    />
                </div>
            </div>

            <button
                type="button"
                onClick={confirmCode}
                className={"w-full font-plexsans font-medium text-[14px] text-ivory bg-tan hover:bg-tanDark rounded-sm py-3.5 mt-5 transition-colors cursor-pointer" + (confirmationCode ? "" : " opacity-50")}
            >
                Confirm user
            </button>

            <div className="flex justify-between mt-6 gap-3 font-plexsans text-[12.5px]">
                <Link to="/signup" className="text-navy underline underline-offset-2">&larr; Back to Home</Link>
                <span onClick={resendCode} className="text-navy underline underline-offset-2 cursor-pointer">Resend code</span>
            </div>
        </div>
        </div>
        </div>
    </div>
  )
}

export default ConfirmationPage
